<div
  *ngIf="modalShow"
  [@inOutOpacity]="animationStateOverlay"
  ngClass="overlay"
  (click)="closeAllModal()"
></div>
@if (!stepModal) {
  <div class="repeat-purchase__main-card" [ngClass]="{'repeat-purchase__main-card__native-app': isMobile}" [@inOutAnimation]="animationState">
    <div ngClass="repeat-purchase__card-title">
      <h2>Your Order</h2>
      <button (click)="closeModal()">
        <img src="assets/svg-icons/close.svg" alt="close tag" />
      </button>
    </div>

    <ng-container *ngIf="hardLoading">
      <div ngClass="repeat-purchase__hard-loading">
        <div class="loading__icon">
          <svg-icon name="spinner" class="spinner"></svg-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isLoading && !hardLoading">
      <div ngClass="repeat-purchase__main-card__loading">
        <div class="loading__icon">
          <svg-icon name="spinner" class="spinner"></svg-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!hardLoading">
      <app-item-card
        [raffles]="raffles"
        [cart]="cart"
        [user]="user"
        [monthlySpend]="monthlySpend"
        [selectedPaymentCard]="selectedPaymentCard"
        [warnMaxTicket]="warnMaxTickets"
        [isGettingTickets]="isGettingTickets"
        (raffleQuantityChange)="handleChangeQuantity($event)"
        (showTokenEditModal)="showTokenEditModal()"
        (postCartAddPopupRaffle)="postCartAddPopupRaffle($event)"
      ></app-item-card>

      <app-promo-code [cart]="cart"></app-promo-code>

      <div ngClass="repeat-purchase__cart">
        <div ngClass="repeat-purchase__cart__subtotal">
          <span>Subtotal</span>
          <span>{{ cart.original_amount | currency: cart.currency }}</span>
        </div>
        <div
          ngClass="repeat-purchase__cart__subtotal"
          *ngIf="cart.coupons.length > 0"
        >
          <span
            >Promo
            <img
              class="repeat-purchase__cart__promo-icon"
              src="assets/svg-icons/shoppingmode.svg"
              alt="discount"
            />
            {{ cart.coupons[0].code }}</span
          >
          <span>-{{ cart.coupons_reduction | currency: cart.currency }}</span>
        </div>
        <div
          ngClass="repeat-purchase__cart__subtotal"
          *ngIf="cart.credits_reduction && cart.credits_reduction > 0"
        >
          <span>Site credit reduction</span>
          <span>-{{ cart.credits_reduction | currency: cart.currency }}</span>
        </div>
        <div ngClass="repeat-purchase__cart__total">
          <span>Total</span>
          <span> {{ cart.cached_amount | currency: cart.currency }}</span>
        </div>
      </div>
      <!-- WIP -->
      <app-heads-up
        [current]="user.current_spend ?? 0"
        [currentMontlhy]="monthlySpend"
        [maxMonthly]="user.monthly_spend_limit ?? 0"
        [currency]="cart.currency"
        [currentCartPrice]="cart.cached_amount"
        (maxMonthlyReached)="handleMaxMonthlyReached($event)"
      />

      <section class="repeat-purchase__caption-tc-privacy">
        <span> By placing your order you agree to our </span>
        <a [routerLink]="termsAndConditions">T&C's</a>.
      </section>
      <section class="repeat-purchase__actions">
        <ng-container *ngIf="isRepeatPurchase && cart.cached_amount >= 500">
          <div
            class="repeat-purchase__actions__checkbox"
            [class]="
              warningRepeatPurchaseAnimation === 'start' &&
              isBlockedRepeatPurchase
                ? 'warning-animation'
                : ''
            "
            [@warningRepeatPurchaseAnimation]="warningRepeatPurchaseAnimation"
          >
            <!-- Active blockage-->
            <img
              [class]="
                isBlockedRepeatPurchase &&
                warningRepeatPurchaseAnimation === 'start'
                  ? ''
                  : 'd-none'
              "
              src="assets/svg-icons/warning-checkbox.svg"
              alt="warning repeat purchase"
            />
            <!-- Inactive blockage-->
            <img
              [class]="
                isBlockedRepeatPurchase &&
                warningRepeatPurchaseAnimation === 'end'
                  ? ''
                  : 'd-none'
              "
              src="assets/svg-icons/inactive-checkbox.svg"
              alt="warning repeat purchase"
            />
            <!-- Checked blockage-->
            <img
              [class]="!isBlockedRepeatPurchase ? '' : 'd-none'"
              src="assets/svg-icons/active-checkbox.svg"
              alt="warning repeat purchase"
            />
            <input
              type="checkbox"
              id="terms-and-conditions"
              class="d-none"
              (change)="handleRepeatPurchaseWarning($event)"
            />
            <label for="terms-and-conditions">
              I understand I'm about to spend over
              {{ 500 | currency: cart.currency }}
            </label>
          </div>
        </ng-container>
        <button
          class="repeat-purchase__actions__card"
          [class]="
            isRepeatPurchase && isBlockedRepeatPurchase ? 'disabled' : ''
          "
          (click)="handlePayment('card')"
          [disabled]="isBlockReasonToBuy || isGettingTickets"
        >
          <span *ngIf="cart.cached_amount > 0">
            Pay {{ cart.cached_amount | currency: cart.currency }} with card
          </span>
          <span *ngIf="cart.cached_amount <= 0"> Place order </span>
        </button>
        <div ngClass="repeat-purchase__actions__divider">
          <div></div>
          <span> or </span>
          <div></div>
        </div>
        <div ngClass="repeat-purchase__actions__group">
          <button
            class="repeat-purchase__actions__paypal"
            (click)="handlePayment('paypal')"
            [disabled]="isBlockReasonToBuy || isGettingTickets"
          >
            <img
              src="assets/svg-icons/paypal-colorfull.svg"
              alt="pay with paypal"
            />
          </button>
        </div>
      </section>
    </ng-container>
  </div>
}
<app-token-card-edit
  [selectedPaymentCard]="selectedPaymentCard"
  [stepModal]="stepModal"
  [paymentCards]="paymentCards"
  [disabled]="isBlockReasonToBuy || isGettingTickets || isProcessing"
  [animationStateTokenEdit]="animationStateTokenEdit"
  [isEditingPaymentCard]="isEditingPaymentCard"
  (hideModalEditToken)="hideTokenEditModal()"
  (handleSubmitNewPayment)="handleNewPaymentMethod()"
></app-token-card-edit>
